import React from 'react'

import ProductDetail from './productdetail'
import useDialogModal from '../hooks/useDialogModal'
import DesktopLineItem from './DesktopLineItem'
import MobileLineItem from './MobileLineItem'
import { Box } from '@mui/material'
import Grid2 from '@mui/material/Unstable_Grid2' // Grid version 2
import * as UID from '../utilities/uniqueKeyForBomTable'
// import { products as data } from '../data'

function getLineItemTotal(
    productRow,
    handleInputChange,
    handleValue,
    isDesktopDisplay
) {
    const productProp = 'lineItemTotal'
    let uuid = UID.getUniqueKeyForBomTable(productRow, productProp)

    return isDesktopDisplay ? (
        <DesktopLineItem
            key={uuid}
            productRow={productRow}
            productProp={productProp}
            handleInputChange={handleInputChange}
            handleValue={handleValue}
            showDialog={null}
        />
    ) : (
        <MobileLineItem
            key={uuid}
            productRow={productRow}
            productProp={productProp}
            handleInputChange={handleInputChange}
            handleValue={handleValue}
            showDialog={null}
        />
    )
}
const gridRowDesktopSx = {
    borderBottom: 0.8,
    borderColor: 'companyColors.accent',
}
const gridRowMobileSx = {
    // flexWrap: 'nowrap',
    justifyContent: 'space-between',
    // marginTop: '2rem',
    // fontSize: '0.8rem',
    border: 1,
    // width: ' 100%',
}
// set a price to $0.00 and it disappears from grid but may be invovled in the estimate calc
function getDisableStatus(price) {
    return price === '$0.00'
}
export default function BomTableRow({
    productRow,
    handleInputChange,
    handleValue,
    isDesktopDisplay,
    invList,
}) {
    const [ProductDetailDialog, showProductDetailDialog] =
        useDialogModal(ProductDetail)

    //

    const gridRowSx = isDesktopDisplay ? gridRowDesktopSx : gridRowMobileSx
    if (getDisableStatus(productRow['sugRetail'])) {
        return null
    }
    let productRowCells = Object.keys(productRow) //  for this array of items
        .filter(
            (productProp) =>
                !['href', 'productIDNum', 'displayOrder'].includes(productProp)
        )
        .reduce((acc, productProp) => {
            let uuid = UID.getUniqueKeyForBomTable(productRow, productProp)
            return isDesktopDisplay
                ? [
                      ...acc,
                      <DesktopLineItem
                          key={uuid}
                          productRow={productRow}
                          productProp={productProp}
                          handleInputChange={handleInputChange}
                          handleValue={handleValue}
                          showDialog={showProductDetailDialog}
                      />,
                  ]
                : [
                      ...acc,
                      <MobileLineItem
                          key={uuid}
                          productRow={productRow}
                          productProp={productProp}
                          handleInputChange={handleInputChange}
                          handleValue={handleValue}
                          showDialog={showProductDetailDialog}
                      />,
                  ]
        }, [])

    productRowCells.push(
        getLineItemTotal(
            productRow,
            handleInputChange,
            handleValue,
            isDesktopDisplay
        )
    )

    const product = invList.find(
        ({ productIDNum }) => productIDNum === productRow.productIDNum
    )
    return (
        <>
            <Box key={productRow.productIDNum} sx={gridRowSx}>
                <Grid2 container columns={20}>
                    {productRowCells}
                </Grid2>
            </Box>
            <ProductDetailDialog product={product} />
        </>
    )
}
